import React from "react";
import './src/styles/global.scss'  
import ZohoSalesIQ from "./src/components/ZohoSalesIQ";

export const wrapRootElement = ({ element }) => (
  <>
    {element}
    <ZohoSalesIQ />
  </>
);
